import { doGet, doPut, doPost, doDelete, doDownloadByPost } from './common';

const terminateById = (id) => {
  return doPut(`/api/order/${id}/terminate`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const draftById = (id) => {
  return doPut(`/api/order/${id}/draft`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const restoreById = (id) => {
  return doPut(`/api/order/${id}/restore`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const download = (id, key) => {
  return doGet(`/api/order/${id}/download/${key}`, null, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const downloadPurchase = (id, date, key) => {
  return doGet(`/api/order/${id}/purchase/download/${date}/key/${key}`, null, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const downloadPackage = (id, package_id) => {
  return doGet(`/api/order/${id}/package/download/${package_id}`, null, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const downloadPalletDetail = (id, package_id) => {
  return doGet(`/api/order/${id}/palletdetail/download/${package_id}`, null, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}


const getPendingList = () => {
  return doGet(`/api/order/pending`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getList = (pagination = undefined, sort = undefined, keyword = undefined) => {
  let filter = '';
  if (pagination) {
    filter = `?limit=${pagination.limit}&offset=${pagination.offset}`;
  }
  if (sort) {
    if (filter !== '') filter += `&sort=${sort}`;
    else filter = `?sort=${sort}`;
  }
  if (keyword) {
    if (filter !== '') filter += `&keyword=${keyword}`;
    else filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/order${filter}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}


const getListCount = (keyword) => {
  let filter = '';
  if (keyword) {
    filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/order/count${filter}`).then(res => (res.data.count))
    .catch(err => { })
    .finally(() => {

    });
}

const getListEnabled = () => {
  return doGet(`/api/order`).then(res => (res.data.filter(x => x.enabled === true)))
    .catch(err => { })
    .finally(() => {

    });
}

const getDeliveryById = (id) => {
  return doGet(`/api/order/${id}/delivery`).then(res => res.data)
    .catch(err => { })
    .finally(() => {

    });
}
const updateDeliveryById = (params) => {
  return doPost(`/api/order/${params.id}/delivery`, params).then(res => res.data)
    .catch(err => { })
    .finally(() => {

    });
}
const getById = (id) => {
  return doGet(`/api/order/${id}`).then(res => res.data)
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (params) => {
  return doPost(`/api/order`, params).then(res => {
    return res.data;
  }
  ).catch(err => {

  }).finally(() => {

  });
}

const update = (params) => {
  return doPut(`/api/order/${params.id}`, params).then(res => {
    return res.data;
  }
  ).catch(err => {

  }).finally(() => {

  });
}

const updateOrderPurchaseSplitCount = (order_id, goods_id, goods_spec_id, params) => {
  return doPut(`/api/order/${order_id}/goods/${goods_id}/spec/${goods_spec_id}/split`, params).then(res => {
    return res.data;
  }
  ).catch(err => {

  }).finally(() => {

  });
}

const getListOrderGoods = (id) => {
  return doGet(`/api/order/${id}/goods`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const insertOrderGoods = (id, params) => {
  return doPost(`/api/order/${id}/goods`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const updateById = (id, params) => {
  return doPut(`/api/order/${id}`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}
const deleteById = (id) => {
  return doDelete(`/api/order/${id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const getPermissionByOrderId = (id) => {
  return doGet(`/api/order/${id}/permission`).then(res => res.data)
    .catch(err => { })
    .finally(() => {

    });
}
const insertPermissionByOrderId = (id, params) => {
  return doPost(`/api/order/${id}/permission`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

/////////////////////////////////////////////////////////////////////////
// Purchase 
/////////////////////////////////////////////////////////////////////////
const updateGoodsSplitSpec = (order_id, pid, params) => {
  return doPost(`/api/order/${order_id}/goods/split/spec/${pid}`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const cancelGoodsSplitSpec = (order_id, pid) => {
  return doDelete(`/api/order/${order_id}/goods/split/spec/${pid}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const updateGoodsSplitCount = (order_id, pid, params) => {
  return doPost(`/api/order/${order_id}/goods/split/count/${pid}`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const cancelGoodsSplitCount = (order_id, pid) => {
  return doDelete(`/api/order/${order_id}/goods/split/count/${pid}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const reviewPurchaseSuppliers = (order_id, params) => {
  return doPut(`/api/order/${order_id}/purchase/review`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderPurchaseByOrderId = (order_id) => {
  return doGet(`/api/order/${order_id}/purchase`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getOrderPurchaseGoodsByOrderId = (order_id) => {
  return doGet(`/api/order/${order_id}/purchase/goods`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderPurchaseGoodsByOrderIdBatch = (order_id) => {
  return doGet(`/api/order/${order_id}/purchase/goods/batch`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const savePurchaseByOrderId = (order_id, params) => {
  return doPost(`/api/order/${order_id}/purchase`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

//////////////////////////////////////////////////////////////////////////
// Package list
const deletePackageNo = (order_id, supplier_id, package_id) => {
  return doDelete(`/api/order/${order_id}/package/supplier/${supplier_id}/no/${package_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getPackageNo = (order_id, supplier_id, package_id) => {
  return doGet(`/api/order/${order_id}/package/supplier/${supplier_id}/no/${package_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertPackageNo = (order_id, supplier_id) => {
  return doPost(`/api/order/${order_id}/package/supplier/${supplier_id}/no`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getPackageNoList = (order_id, supplier_id) => {
  return doGet(`/api/order/${order_id}/package/supplier/${supplier_id}/no`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderPackageGoodsBySupplierId = (order_id, supplier_id) => {
  return doGet(`/api/order/${order_id}/goods/supplier/${supplier_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertSelfPackagePallet = (order_id, params) => {
  return doPost(`/api/order/${order_id}/package/pallet`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const deleteSelfPackagePallet = (order_id, pallet_id) => {
  return doDelete(`/api/order/${order_id}/package/pallet/${pallet_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertSelfPackage = (order_id, params) => {
  return doPost(`/api/order/${order_id}/package/carton`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const updatePalletReviceStatus = (order_id, pallet_id, params) => {
  return doPut(`/api/order/${order_id}/package/pallet/${pallet_id}/recive`, params).then(res => res.data)
    .catch(err => { })
    .finally(() => {

    });
}
const updateCartonReviceStatus = (order_id, carton_id, params) => {
  return doPut(`/api/order/${order_id}/package/carton/${carton_id}/recive`, params).then(res => res.data)
    .catch(err => { })
    .finally(() => {

    });
}
const deleteSelfPackage = (order_id, carton_id) => {
  return doDelete(`/api/order/${order_id}/package/carton/${carton_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getSupplierByOrderid = (order_id) => {
  return doGet(`/api/order/${order_id}/supplier`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getOrderPackageList = (order_id) => {
  return doGet(`/api/order/${order_id}/package`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const updateOrderPackageCartonState = (order_id, package_id, carton_id, body) => {
  return doPut(`/api/order/${order_id}/package/${package_id}/carton/${carton_id}`, body).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const splitPackageCartonCount = (order_id, pkg_id, ds, params) => {
  return doPost(`/api/order/${order_id}/package/${pkg_id}/split/${ds}`, params).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}

const getOrderPendingPackageList = (order_id) => {
  return doGet(`/api/order/${order_id}/package/pending`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderPackageProgress = (order_id) => {
  return doGet(`/api/order/${order_id}/package/progress`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getOrderPackagePalletList = (order_id) => {
  return doGet(`/api/order/${order_id}/package/pallet`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderPackageListBySupplierId = (order_id, supplier_id) => {
  return doGet(`/api/order/${order_id}/package/supplier/${supplier_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const updateOrderDeliveriedStatus = (order_id, supplier_id) => {
  return doPost(`/api/order/${order_id}/delivery/${supplier_id}/status`, {}).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderPackageNoList = (order_id) => {
  return doGet(`/api/order/${order_id}/package/no`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const syncOrderPackageNo = (order_id, package_id) => {
  return doPut(`/api/order/${order_id}/package/${package_id}/sync`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const returnOrderPackageNo = (order_id, package_id) => {
  return doPut(`/api/order/${order_id}/package/${package_id}/return`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const syncOrderPackages = (order_id) => {
  return doGet(`/api/order/${order_id}/package/sync`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const returnOrderPackages = (order_id, supplier_id, delivery_date) => {
  return doGet(`/api/order/${order_id}/package/${supplier_id}/return/${delivery_date}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const insertOrderPackageFillType = (order_id, params) => {
  return doPost(`/api/order/${order_id}/package/fill/type`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
////////////////////////////////////////////////////////////////////////
// Supplier
const getOrderListBySupplierId = () => {
  return doGet(`/api/order/supplier`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getOrderGoodsList = (order_id) => {
  return doGet(`/api/order/${order_id}/goods/supplier`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getSupplierReturnPackage = () => {
  return doGet(`/api/supplier/interface/package/return`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getSupplierById = () => {
  return doGet(`/api/supplier/interface/supplier`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const deletePackageCarton = (order_id, carton_id) => {
  return doDelete(`/api/supplier/interface/package/order/${order_id}/carton/${carton_id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}
const insertPackageCarton = (order_id, params) => {
  return doPost(`/api/supplier/interface/package/order/${order_id}/carton`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const insertPackageCartons = (order_id, params) => {
  return doPost(`/api/supplier/interface/package/order/${order_id}/cartons`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const updatePackageCarton = (order_id, carton_id, params) => {
  return doPut(`/api/supplier/interface/package/order/${order_id}/carton/${carton_id}`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertPackagePallet = (order_id, params) => {
  return doPost(`/api/supplier/interface/package/order/${order_id}/pallet`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getPackageList = (order_id) => {
  return doGet(`/api/supplier/interface/package/order/${order_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getPackagePalletList = (order_id) => {
  return doGet(`/api/supplier/interface/package/order/${order_id}/pallet`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const deletePackageByPalletId = (order_id, pallet_id) => {
  return doDelete(`/api/supplier/interface/package/order/${order_id}/pallet/${pallet_id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const insertPackageDelivery = (order_id, params) => {
  return doPost(`/api/supplier/interface/package/order/${order_id}/delivery`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getPackageDeliveryList = (order_id) => {
  return doGet(`/api/supplier/interface/package/order/${order_id}/delivery`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const deletePackageDeliveryByDeliveryId = (order_id, delivery_id) => {
  return doDelete(`/api/supplier/interface/package/order/${order_id}/delivery/${delivery_id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const downloadDelivery = (order_id, no_id) => {
  return doGet(`/api/supplier/interface/package/order/${order_id}/no/${no_id}/download`, null, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const downloadDeliveryPost = (order_id, no_id, body) => {
  return doDownloadByPost(`/api/supplier/interface/package/order/${order_id}/no/${no_id}/download`, body, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const downloadPalletDetailSupplier = (order_id, no_id) => {
  return doGet(`/api/supplier/interface/package/order/${order_id}/palletdetail/${no_id}/download`, null, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const deletePackageNoSupplier = (order_id, package_id) => {
  return doDelete(`/api/supplier/interface/package/order/${order_id}/no/${package_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertPackageNoSupplier = (order_id, params) => {
  return doPost(`/api/supplier/interface/package/order/${order_id}/no`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertPackageNoNotificationSupplier = (order_id, params) => {
  return doPost(`/api/supplier/interface/package/order/${order_id}/no/notification`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertPackageNoApplyEditNotificationSupplier = (order_id, package_id, params) => {
  return doPost(`/api/supplier/interface/package/order/${order_id}/no/${package_id}/applyedit`, params).then(res => (res.data))
    .catch(err => { alert(JSON.stringify(err)) })
    .finally(() => {

    });
}
const getPackageNoListSupplier = (order_id) => {
  return doGet(`/api/supplier/interface/package/order/${order_id}/no`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const updatePackageNoSupplierRemark = (order_id, package_id, params) => {
  return doPut(`/api/supplier/interface/package/order/${order_id}/no/${package_id}/remark`, params).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const deletePackageListSupplierByNo = (order_id, package_id) => {
  return doDelete(`/api/supplier/interface/package/order/${order_id}/no/${package_id}/list`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
export {
  terminateById,
  draftById,
  restoreById,
  download,
  downloadPurchase,
  downloadPackage,
  downloadPalletDetail,
  getList,
  getPendingList,
  getListCount,
  getListEnabled,
  getDeliveryById,
  getById,
  updateById,
  insert,
  update,
  updateDeliveryById,
  insertOrderGoods,
  getListOrderGoods,
  deleteById,
  getPermissionByOrderId,
  insertPermissionByOrderId,
  getOrderPurchaseByOrderId,
  getOrderPurchaseGoodsByOrderId,
  getOrderPurchaseGoodsByOrderIdBatch,
  savePurchaseByOrderId,
  reviewPurchaseSuppliers,
  getOrderPackageGoodsBySupplierId,
  getOrderPackageList,
  splitPackageCartonCount,
  getOrderPendingPackageList,
  getOrderPackageProgress,
  getOrderPackagePalletList,
  getOrderPackageListBySupplierId,
  getOrderListBySupplierId,
  getOrderGoodsList,
  getSupplierById,
  deletePackageByPalletId,
  getPackagePalletList,
  getPackageList,
  insertPackagePallet,
  insertPackageCarton,
  insertPackageCartons,
  deletePackageCarton,
  updatePackageCarton,
  insertPackageDelivery,
  getPackageDeliveryList,
  deletePackageDeliveryByDeliveryId,
  downloadDelivery,
  downloadDeliveryPost,
  downloadPalletDetailSupplier,
  updateOrderPurchaseSplitCount,
  updateGoodsSplitCount,
  cancelGoodsSplitCount,
  updateGoodsSplitSpec,
  cancelGoodsSplitSpec,
  syncOrderPackages,
  syncOrderPackageNo,
  returnOrderPackageNo,
  getOrderPackageNoList,
  returnOrderPackages,
  getSupplierByOrderid,
  insertOrderPackageFillType,
  insertSelfPackagePallet,
  insertSelfPackage,
  deleteSelfPackagePallet,
  deleteSelfPackage,
  insertPackageNo,
  deletePackageNo,
  getPackageNo,
  getPackageNoList,
  insertPackageNoSupplier,
  insertPackageNoNotificationSupplier,
  insertPackageNoApplyEditNotificationSupplier,
  deletePackageNoSupplier,
  getPackageNoListSupplier,
  updatePackageNoSupplierRemark,
  deletePackageListSupplierByNo,
  updatePalletReviceStatus,
  updateCartonReviceStatus,
  updateOrderDeliveriedStatus,
  getSupplierReturnPackage,
  updateOrderPackageCartonState
}